export default __webpack_public_path__ + "static/media/background.4b984b1b.png";